import {CA} from '../../analytics/Analytics'
import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'
import {AnalyticEventCategory, AnalyticEventType, AnalyticEventValue, MobileImageSharingAnalytics} from '../../../../../shared/entity_datas/EntityDatas'
import {UIEndGameShareImage} from '../../ui_share_image/UIEndGameShareImage'
import {UIEndGameTitleImage} from '../../ui_share_image/UIEndGameTitleImage'
import {UIGameManager} from '../UIGameManager'
import {UIGameEndController} from './UIGameEndController'
import {ViewPopupShareImage} from '../../ui_popup/ViewPopupShareImage'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {clientI18n} from '../../ClientI18n'
import {UIUrlParameterNames} from '../../ui_html/UIUrlController'
import {UIDeviceController} from '../../ui_html/UIDeviceController'
import {uiManagerEvents} from '../../EntryShared'
import {UIPopupController} from '../../ui_popup/UIPopupController'

export class UIGameEndShareButtonController {
    private readonly uiGameManager: UIGameManager
    private readonly gameEndController: UIGameEndController

    private shareImage?: UIEndGameShareImage
    private readonly titleImage?: UIEndGameTitleImage

    private shareImagePopup: ViewPopupShareImage

    constructor(uiGameManager: UIGameManager, gameEndController: UIGameEndController) {
        this.uiGameManager = uiGameManager
        this.gameEndController = gameEndController

        if(this.gameEndController.endGamePlayerState?.title != null) {
            this.titleImage = new UIEndGameTitleImage(this.uiGameManager, this.gameEndController.endGamePlayerState.title, this.gameEndController.endGameState)
        }

        if(this.shouldShowShareGameResultsPopupAutomaticallyOnGameEnd()) this.createShareImagePopupIfNotExist(true)
    }

    onClickShare() {
        this.createShareImagePopupIfNotExist()

        UIGameEndShareButtonController.sendShareButtonClickAnalytic()
    }

    private createShareImagePopupIfNotExist(delay: boolean = false) {
        if(this.isPopupRemovedOrDoesNotExist()) {
            if(delay) {
                setTimeout(() => this.createShareImagePopupIfNotExist(), 3000)
                return
            }

            this.shareImage = new UIEndGameShareImage(this.uiGameManager, this.gameEndController.endGameState)
            this.shareImagePopup = this.titleImage ? new ViewPopupShareImage(this.titleImage, this.shareImage, true) : new ViewPopupShareImage(this.shareImage)

            if(UIUtilsEjsVariables.isUserOnDiscord) {
                this.setShareActionOnDiscord()
                return
            }

            if(UIUtilsEjsVariables.isUserOnMobile) this.setShareActionOnMobile()
        }
    }

    private isPopupRemovedOrDoesNotExist(): boolean {
        if(this.shareImagePopup == undefined) return true
        if(this.shareImagePopup.isPopupRemoved()) return true
        return false
    }

    private shouldShowShareGameResultsPopupAutomaticallyOnGameEnd(): boolean {
        if(this.uiGameManager.gameController.isReplay) return false
        if(UIUtilsEjsVariables.isUserOnDiscord) return true
        return false
    }

    private static sendShareButtonClickAnalytic() {
        const endGameShareEvent: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.EndGameShareButton,
            category: AnalyticEventCategory.Virality,
            floatValue: AnalyticEventValue.EndGameShareButton,
        }
        void CA.sendAnalyticEventOnce(endGameShareEvent)
    }

    private static sendDiscordShareAnalytic() {
        const discordShareClickEvent: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.EndGameShareButton,
            category: AnalyticEventCategory.Virality,
            floatValue: AnalyticEventValue.EndGameShareDiscordButton,
        }
        void CA.sendAnalyticEventOnce(discordShareClickEvent)
    }

    private static sendMobileShareAnalytic() {
        const mobileShareClickEvent: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.EndGameShareButton,
            category: AnalyticEventCategory.Virality,
            floatValue: AnalyticEventValue.EndGameShareMobileButton,
        }
        void CA.sendAnalyticEventOnce(mobileShareClickEvent)
    }

    private static fileToDataUrl(file: File): Promise<string | undefined> {
        return new Promise((resolve) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result as string)
            reader.onerror = () => resolve(undefined)
            reader.readAsDataURL(file)
        })
    }

    private setShareActionOnDiscord() {
        const shareAction = async(image: UIEndGameShareImage) => {
            const imageFile = await image.getImageFile()
            if(imageFile == undefined) return

            uiManagerEvents.shareImage(undefined, undefined, undefined, imageFile, undefined)

            UIGameEndShareButtonController.sendDiscordShareAnalytic()
        }

        this.shareImagePopup.setShareAction(shareAction)
    }

    private setShareActionOnMobile() {
        const shareAction = async(image: UIEndGameShareImage) => {
            if(UIDeviceController.isUserOnFirefox()) {
                UIPopupController.createSimplePopup({key: 'strings:popups.errors.sharingNotSupportedOnFirefox.title'}, {key: 'strings:popups.errors.sharingNotSupportedOnFirefox.message'})
                return
            }

            const title = clientI18n.t('strings:game.endGame.shareImagePopup.title')
            const text = clientI18n.t('strings:homePage.popups.discordShareActivity.text')
            const link = `${window.location.origin}/mobile#${UIUrlParameterNames.MobileImageSharing}=${MobileImageSharingAnalytics[MobileImageSharingAnalytics.GameResultsSharedFromGameEndScreen]}`
            const imageFile = await image.getImageFile() as File
            const imageSrc = await UIGameEndShareButtonController.fileToDataUrl(imageFile)
            if(imageSrc == undefined) return

            uiManagerEvents.shareImage(title, text, link, imageFile, imageSrc)

            UIGameEndShareButtonController.sendMobileShareAnalytic()
        }

        this.shareImagePopup.setShareAction(shareAction)
    }
}
